export default class General {
    constructor() {
        this.app = document.getElementById('app');

        window.addEventListener('load', () => {
            if (this.app) {
                this.calcHeaderHeight();
                this.calcFooterHeight();
            }
        });

        window.addEventListener('resize', () => {
            if (this.app) {
                this.calcHeaderHeight();
                this.calcFooterHeight();
            }
        });
    }

    calcHeaderHeight() {
        let header = document.querySelector('header');
        if (header) {
            document.body.style.setProperty('--header-height', `${header.getBoundingClientRect().height}px`);
        }
    }

    calcFooterHeight() {
        let footer = document.querySelector('footer');
        if (footer) {
            document.body.style.setProperty('--footer-height', `${footer.getBoundingClientRect().height}px`);
        }
    }
}
